import { EnvSettings } from 'src/environments/environment';

export class Settings {
  public static version = '1.5.16';
  public static environmentSettingsFile = EnvSettings.environmentSettingsFile;
  public static debug = EnvSettings.debug;
  public static showErrorsInConsole = EnvSettings.showErrorsInConsole;
  public static baseUrlBackend = EnvSettings.baseUrlBackend;
  public static clientId = EnvSettings.clientId;
  public static notAuthorizedVideoURL = EnvSettings.notAuthorizedVideoURL;
  public static signUpURL = EnvSettings.signUpURL;
  public static playerURL = EnvSettings.playerURL;
  public static backendRedirectURL = EnvSettings.backendRedirectURL;
  public static emptyPlaylistVideoURL = EnvSettings.emptyPlaylistVideoURL;
  public static externalLoginURL = EnvSettings.externalLoginURL;
  public static redirectURLAfterSuccessfulSubscription = EnvSettings.redirectURLAfterSuccessfulSubscription;
  public static redirectionAfterSuccessfulSubscriptionTimeout = EnvSettings.redirectionAfterSuccessfulSubscriptionTimeout;
}
